/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_Sign_In_ExistingInputs */

const en_landing_cta_sign_in_existing = /** @type {(inputs: Landing_Cta_Sign_In_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to existing account`)
};

const de_landing_cta_sign_in_existing = /** @type {(inputs: Landing_Cta_Sign_In_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei bestehendem Konto anmelden`)
};

const fr_landing_cta_sign_in_existing = /** @type {(inputs: Landing_Cta_Sign_In_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter à un compte existant`)
};

const es_landing_cta_sign_in_existing = /** @type {(inputs: Landing_Cta_Sign_In_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión en cuenta existente`)
};

const it_landing_cta_sign_in_existing = /** @type {(inputs: Landing_Cta_Sign_In_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi all'account esistente`)
};

const nl_landing_cta_sign_in_existing = /** @type {(inputs: Landing_Cta_Sign_In_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen op bestaand account`)
};

const pl_landing_cta_sign_in_existing = /** @type {(inputs: Landing_Cta_Sign_In_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się na istniejące konto`)
};

const fi_landing_cta_sign_in_existing = /** @type {(inputs: Landing_Cta_Sign_In_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu olemassa olevalle tilille`)
};

const da_landing_cta_sign_in_existing = /** @type {(inputs: Landing_Cta_Sign_In_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind på eksisterende konto`)
};

const sv_landing_cta_sign_in_existing = /** @type {(inputs: Landing_Cta_Sign_In_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in på befintligt konto`)
};

/**
* | output |
* | --- |
* | "Sign in to existing account" |
*
* @param {Landing_Cta_Sign_In_ExistingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_cta_sign_in_existing = /** @type {((inputs?: Landing_Cta_Sign_In_ExistingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_Sign_In_ExistingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_cta_sign_in_existing(inputs)
	if (locale === "fr") return fr_landing_cta_sign_in_existing(inputs)
	if (locale === "es") return es_landing_cta_sign_in_existing(inputs)
	if (locale === "it") return it_landing_cta_sign_in_existing(inputs)
	if (locale === "nl") return nl_landing_cta_sign_in_existing(inputs)
	if (locale === "pl") return pl_landing_cta_sign_in_existing(inputs)
	if (locale === "fi") return fi_landing_cta_sign_in_existing(inputs)
	if (locale === "da") return da_landing_cta_sign_in_existing(inputs)
	if (locale === "sv") return sv_landing_cta_sign_in_existing(inputs)
	return en_landing_cta_sign_in_existing(inputs)
});